import { UPDATE_LOGO_SELECTOR_TAG, GO_TO_PURPOSE_PAGE, GO_BACK, SKIP_AND_GO_TO_PURPOSE_PAGE } from '../mainActionTypes';

export function updateLogoSelectorTag(tag) {
  return {
    type: UPDATE_LOGO_SELECTOR_TAG,
    payload: tag
  };
}

export function goToPurpose() {
  return {
    type: GO_TO_PURPOSE_PAGE
  };
}

export function goBack() {
  return {
    type: GO_BACK
  };
}

export function skipTagsPage() {
  return {
    type: SKIP_AND_GO_TO_PURPOSE_PAGE
  };

}
